import { FC } from 'react'
import styled from 'styled-components'
import ClearIcon from '@tuhi/components/assets/icons/buttons/clear.svg'
import { Text } from '../text/textStyles'
import { BaseButton } from '../../components'
import { contentColorStyle } from '../buttons/button'

const Container = styled.button<{ $isSelected: boolean }>`
    cursor: pointer;
    display: flex;
    padding: 4px 10px;
    justify-content: center;
    align-items: center;
    gap: 10px;

    border-radius: 5px;
    border: 1px solid
        ${(p) =>
            p.$isSelected
                ? `${p.theme.colors.secondary.secondary800}`
                : `${p.theme.colors.tertiary.tertiary300}`};

    background-color: ${(p) => p.theme.colors.white};

    ${(p) =>
        contentColorStyle(
            p.$isSelected
                ? p.theme.colors.secondary.secondary800
                : p.theme.colors.tertiary.tertiary600
        )}
`

interface Props {
    text: string
    isSelected: boolean
    onClick: () => void
    onDismiss: () => void
}

export const FilterChip: FC<Props> = ({
    isSelected,
    text,
    onClick,
    onDismiss,
}) => {
    return (
        <Container $isSelected={isSelected} onClick={onClick}>
            <Text size={'xxSmall'} $weight={'semiBold'} color="none">
                {text}
            </Text>

            {isSelected && (
                <BaseButton
                    onClick={(e) => {
                        e.stopPropagation()
                        onDismiss()
                    }}
                >
                    <ClearIcon />
                </BaseButton>
            )}
        </Container>
    )
}
